import { RowInterface } from "./typing";

export default function Row({ children, className = "", gap = 4, cols = 2 }: RowInterface) {
  return <div className={`grid grid-cols-${cols} gap-${gap} ${className}`}>{children}</div>;
}
